export default __webpack_public_path__ + "static/media/2737.9e1e29d1.svg";